import { T } from '@transifex/react';
import { cn } from '~/lib/utils';
import { progressiveValidationMapping } from '~/lib/validation';

type PasswordRequirementsProps = {
  errors?: string[];
};

export function PasswordRequirements({ errors = [] }: PasswordRequirementsProps) {
  return (
    <p className="text-body-caption text-text-700">
      <T
        _str="Use {charLimit} with {letter}, {number} and {special}"
        special={
          <span
            className={cn(
              !errors.includes(progressiveValidationMapping.specialChar)
                ? 'text-green-700'
                : 'text-text-500'
            )}
          >
            <T _str="1 special character" />
          </span>
        }
        number={
          <span
            className={cn(
              !errors.includes(progressiveValidationMapping.number)
                ? 'text-green-700'
                : 'text-text-500'
            )}
          >
            <T _str="1 number" />
          </span>
        }
        letter={
          <span
            className={cn(
              !errors.includes(progressiveValidationMapping.letter)
                ? 'text-green-700'
                : 'text-text-500'
            )}
          >
            <T _str="at least 1 letter" />
          </span>
        }
        charLimit={
          <span
            className={cn(
              !errors.includes(progressiveValidationMapping.charLimit)
                ? 'text-green-700'
                : 'text-text-500'
            )}
          >
            <T _str="8 or more characters" />
          </span>
        }
      />
    </p>
  );
}
